import React from 'react';
import { getBezierPath, getSmoothStepPath } from 'reactflow';
import {
    FilterOutlined,
    WarningOutlined,
    ClockCircleOutlined,
    CalendarOutlined,
    SwapOutlined,
    PartitionOutlined,
} from '@ant-design/icons';

const ICON_SIZE = 22;

const ICON_MAP = {
    filter: FilterOutlined,
    warning: WarningOutlined,
    clock: ClockCircleOutlined,
    calendar: CalendarOutlined,
    swap: SwapOutlined,
    partition: PartitionOutlined,
};

export default function IconEdge({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style = {},
    markerEnd,
    label,
    labelStyle,
    labelBgStyle,
    labelBgPadding,
    labelBgBorderRadius,
    data,
    animated,
}) {
    const isSmooth = data?.smoothstep;
    const pathFn = isSmooth ? getSmoothStepPath : getBezierPath;

    const smoothOpts = isSmooth ? {
        borderRadius: 16,
        offset: Math.max(40, Math.abs(sourceX - targetX) * 0.3),
    } : {};

    const [edgePath, labelX, labelY] = pathFn({
        sourceX,
        sourceY,
        targetX,
        targetY,
        sourcePosition,
        targetPosition,
        ...smoothOpts,
    });

    const iconKey = data?.icon;
    const IconComponent = iconKey ? ICON_MAP[iconKey] : null;
    const iconColor = data?.iconColor || style.stroke || '#666';

    const iconOffsetY = label ? -14 : 0;

    return (
        <>
            <path
                id={id}
                className={`react-flow__edge-path${animated ? ' edge-animated' : ''}`}
                d={edgePath}
                style={style}
                markerEnd={markerEnd}
            />

            {label && (
                <>
                    <rect
                        className="react-flow__edge-textbg"
                        x={labelX - 30}
                        y={labelY - 7}
                        width={60}
                        height={14}
                        rx={labelBgBorderRadius || 3}
                        style={labelBgStyle}
                    />
                    <text
                        className="react-flow__edge-text"
                        x={labelX}
                        y={labelY}
                        textAnchor="middle"
                        dominantBaseline="central"
                        style={labelStyle}
                    >
                        {label}
                    </text>
                </>
            )}

            {IconComponent && (
                <foreignObject
                    x={labelX - ICON_SIZE / 2}
                    y={labelY + iconOffsetY - ICON_SIZE / 2}
                    width={ICON_SIZE}
                    height={ICON_SIZE}
                    className="edge-icon-badge"
                    requiredExtensions="http://www.w3.org/1999/xhtml"
                >
                    <div
                        xmlns="http://www.w3.org/1999/xhtml"
                        style={{
                            width: ICON_SIZE,
                            height: ICON_SIZE,
                            borderRadius: '50%',
                            background: '#fff',
                            border: `2px solid ${iconColor}`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
                        }}
                    >
                        <IconComponent style={{ fontSize: 11, color: iconColor }} />
                    </div>
                </foreignObject>
            )}
        </>
    );
}
